import Vue from 'vue'
import Router from 'vue-router'

/* Layout */
import Layout from '../views/layout/Layout'

Vue.use(Router)

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 */
export const constantRouterMap = [
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '*',
    component: () => import('@/views/NotFoundPage'),
    hidden: true
  }, // 현재 정의 되지 않은 페이지 접근시 이동 하는 페이지
  {
    path: '',
    component: Layout,
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/home/index'),
        meta: { title: '메인', icon: 'home' }
      }
    ]
  },
  {
    path: '/guide',
    component: Layout,
    children: [
      {
        path: 'first',
        name: 'first',
        component: () => import('@/views/guide/FirstGuide'),
        meta: { title: '사이트소개', icon: 'home' }
      },
      {
        path: 'seller',
        name: 'seller',
        component: () => import('@/views/guide/SellerGuide'),
        meta: { title: '판매자가이드', icon: 'home' }
      },
      {
        path: 'vendor',
        name: 'vendor',
        component: () => import('@/views/guide/VendorGuide'),
        meta: { title: '공급사가이드', icon: 'home' }
      }
    ]
  },
  {
    path: '/info',
    component: Layout,
    children: [
      {
        path: 'agreement',
        name: 'agreement',
        component: () => import('@/views/policy/Agreement'),
        meta: { title: '이용약관', icon: 'home' }
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: () => import('@/views/policy/Privacy'),
        meta: { title: '개인정보취급방침', icon: 'home' }
      },
      {
        path: 'responsibility',
        name: 'responsibility',
        component: () => import('@/views/policy/Responsibility'),
        meta: { title: '책임의한계및법적고지', icon: 'home' }
      }
    ]
  },
  {
    path: '/login',
    component: Layout,
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('@/views/login/index'),
        meta: { title: '로그인', icon: 'home' }
      }
    ]
  },
  {
    path: '/cart',
    component: Layout,
    children: [
      {
        path: '',
        name: 'cart',
        component: () => import('@/views/cart/index'),
        meta: { title: '장바구니', icon: 'home' }
      }
    ]
  },
  {
    path: '/payment',
    component: Layout,
    children: [
      {
        path: '',
        name: 'payment',
        component: () => import('@/views/order/payment/index'),
        meta: { title: '결제하기', icon: 'home' }
      }
    ]
  },
  {
    path: '/payment/success/:orderCode',
    component: Layout,
    children: [
      {
        path: '',
        name: 'orderSuccess',
        component: () => import('@/views/order/payment/success'),
        meta: { title: '주문완료', icon: 'home' },
        hidden: true
      }
    ]
  },
  {
    path: '/join',
    component: Layout,
    children: [
      {
        path: '',
        name: 'join',
        component: () => import('@/views/join/index'),
        meta: { title: '회원가입', icon: 'home' }
      }
    ]
  },
  {
    path: '/mypage',
    name: 'mypage',
    component: Layout,
    redirect: '/mypage/orderList',
    meta: { title: '마이페이지', icon: 'nav_ico' },
    children: [
      {
        path: 'orderList',
        name: 'orderList',
        component: () => import('@/views/mypage/OrderDeliveryList'),
        meta: { title: '주문배송조회', icon: 'nav_ico' },
        hidden: true
      },
      {
        path: 'orderDetail/:orderCode',
        name: 'orderDetail',
        component: () => import('@/views/mypage/OrderDeliveryDetail'),
        meta: { title: '주문배송상세조회', icon: 'nav_ico' },
        hidden: true
      },
      {
        path: 'orderExcel',
        name: 'orderExcel',
        component: () => import('@/views/mypage/excel/index'),
        meta: { title: '엑셀대량주문', icon: 'nav_ico' },
        hidden: true
      },
      {
        path: 'favor',
        name: 'favor',
        component: () => import('@/views/mypage/FavorList'),
        meta: { title: '찜한상품', icon: 'nav_ico' },
        hidden: true
      },
      {
        path: 'tax',
        name: 'tax',
        component: () => import('@/views/mypage/TaxList'),
        meta: { title: '세금계산서내역', icon: 'nav_ico' },
        hidden: true
      },
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/mypage/member/index'),
        meta: { title: '회원정보 수정', icon: 'nav_ico' },
        hidden: true
      },
      {
        path: 'point',
        name: 'point',
        component: () => import('@/views/mypage/point/index'),
        meta: { title: '적립금충전', icon: 'nav_ico' }
      },
      {
        path: 'productUpdateList',
        name: 'productUpdateList',
        component: () => import('@/views/mypage/ProductUpdateList'),
        meta: { title: '상품수정리스트', icon: 'nav_ico' }
      },
      {
        path: 'productDownload',
        name: 'productDownload',
        component: () => import('@/views/mypage/productDownload/index'),
        meta: { title: '상품DB다운로드', icon: 'nav_ico' }
      },
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/mypage/notice/index'),
        meta: { title: '공지사항', icon: 'nav_ico' }
      },
      {
        path: 'qna',
        name: 'qna',
        component: () => import('@/views/mypage/qna/index'),
        meta: { title: '1:1문의', icon: 'nav_ico' }
      },
      {
        path: 'faq',
        name: 'faq',
        component: () => import('@/views/mypage/FaqList'),
        meta: { title: '자주묻는질문', icon: 'nav_ico' }
      },
      {
        path: 'alarm',
        name: 'alarm',
        component: () => import('@/views/mypage/AlarmList'),
        meta: { title: '긴급/알림메모', icon: 'nav_ico' }
      },
      {
        path: 'deposit/refund',
        name: 'depositRefund',
        component: () => import('@/views/mypage/deposit/index'),
        meta: { title: '적립금 환불', icon: 'nav_ico' }
      }
    ]
  },
  {
    path: '/detail/:id',
    component: Layout,
    children: [
      {
        path: '',
        name: 'detail',
        component: () => import('@/views/product/ProductDetail'),
        meta: { title: '상품 상세 정보', icon: 'nav_ico' }
      }
    ]
  },
  {
    path: '/productList',
    component: Layout,
    children: [
      {
        path: '',
        name: 'productList',
        component: () => import('@/views/product/product-list/index'),
        meta: { title: '상품 목록', icon: 'nav_ico' }
      }
    ]
  },
  {
    path: '/vendor',
    component: Layout,
    children: [
      {
        path: 'join',
        name: 'vendorJoin',
        component: () => import('@/views/vendor/join/index'),
        meta: { title: '공급사 임점', icon: 'home' }
      },
      {
        path: 'search',
        name: 'joinSearch',
        component: () => import('@/views/vendor/search/index'),
        meta: { title: '공급사 입점 조회', icon: 'home' }
      }
    ]
  }
]

// 동일한 라우터 이동시 예외 처리
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}
export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js